import Field, { FieldType } from "@dto/fields";
import { ObjectInfos } from "@dto/objects";
import { ObjectRelation } from "@dto/relation";
import { FIELD_SEPARATOR, SOURCE_SEPARATOR } from "@utils/constants";
import { fieldToPath, pathKey } from "@utils/model";

// Path key of a field used as an operand of a SUM / LOOKUP condition. A LINK
// field has no stored value (the link is an edge of the relation): it is
// referenced by its link column path ("obj/link:rel-DIR>target/field"), which
// the server compares by linked record when both sides are links.
export function conditionOperandPathKey(objectKey: string, field: Field, relationByKeys: Map<string, ObjectRelation> | null, fieldByKeys: Map<string, Field> | null): string {
    if (field.type === FieldType.Link) {
        const path = fieldToPath(objectKey, relationByKeys, fieldByKeys, field);
        if (path) {
            return pathKey(path);
        }
    }
    return SOURCE_SEPARATOR + objectKey + FIELD_SEPARATOR + field._key;
}

type LinkFieldLabel = {
    name: string;
    // Link column path: the path a label is converted to
    columnPathKey: string;
    // Bare path (":obj/link") written by the previous condition builder
    barePathKey: string;
};

// Labels of the LINK fields of the objects ("Accueil > Établissement"): the
// field trees of the formula editor only hold the fields which have a value.
function linkFieldLabels(objectInfos: ObjectInfos[], relationByKeys: Map<string, ObjectRelation> | null, fieldByKeys: Map<string, Field> | null): LinkFieldLabel[] {
    const labels: LinkFieldLabel[] = [];
    objectInfos.forEach(objectInfo => {
        const objectKey = objectInfo.object._key;
        objectInfo.fields?.forEach(field => {
            if (field.type !== FieldType.Link) {
                return;
            }
            const path = fieldToPath(objectKey, relationByKeys, fieldByKeys, field);
            if (!path) {
                return;
            }
            labels.push({
                name: objectInfo.object.name + " > " + field.name,
                columnPathKey: pathKey(path),
                barePathKey: SOURCE_SEPARATOR + objectKey + FIELD_SEPARATOR + field._key,
            });
        });
    });
    return labels;
}

export function fillWithLinkFieldPathKeyToNameMap(objectInfos: ObjectInfos[], map: Map<string, string>, relationByKeys: Map<string, ObjectRelation> | null, fieldByKeys: Map<string, Field> | null) {
    linkFieldLabels(objectInfos, relationByKeys, fieldByKeys).forEach(label => {
        map.set(label.columnPathKey, label.name);
        map.set(label.barePathKey, label.name);
    });
}

export function fillWithLinkFieldNameToPathKeyMap(objectInfos: ObjectInfos[], map: Map<string, string>, relationByKeys: Map<string, ObjectRelation> | null, fieldByKeys: Map<string, Field> | null) {
    linkFieldLabels(objectInfos, relationByKeys, fieldByKeys).forEach(label => {
        map.set(label.name, label.columnPathKey);
    });
}
